import { useEffect } from 'react';
import { useSeoData } from '../contexts/SeoDataContext';

// Injects admin-managed raw code (dashboard: Settings → SEO → Header/Body
// Code) into the document. Used for Google Tag Manager, Google Analytics,
// Meta Pixel, site-verification tags, etc. — anything that needs to live in
// <head> or right inside <body>.
//
// A <script> set via innerHTML never executes, so each script node is
// recreated as a real element. Everything else (e.g. GTM's <noscript>
// fallback) is cloned as-is. Injected nodes are tagged so they can be removed
// and re-applied cleanly when the settings change.
function injectInto(target, html, marker) {
  if (!html || !html.trim()) return [];

  const template = document.createElement('template');
  template.innerHTML = html;

  const inserted = [];
  Array.from(template.content.childNodes).forEach((node) => {
    let el;
    if (node.tagName === 'SCRIPT') {
      el = document.createElement('script');
      for (const attr of node.attributes) {
        el.setAttribute(attr.name, attr.value);
      }
      el.textContent = node.textContent;
    } else {
      el = node.cloneNode(true);
    }
    if (el.setAttribute) el.setAttribute('data-injected', marker);
    target.appendChild(el);
    inserted.push(el);
  });

  return inserted;
}

export default function CustomCodeInjector() {
  const { settings } = useSeoData();
  const headerCode = settings?.header_code || '';
  const bodyCode = settings?.body_code || '';

  useEffect(() => {
    const nodes = [
      ...injectInto(document.head, headerCode, 'seo-header'),
      ...injectInto(document.body, bodyCode, 'seo-body'),
    ];
    return () => {
      nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
    };
  }, [headerCode, bodyCode]);

  return null;
}
